export enum ApiQueryKey {
  Dictionary = 'api/dictionary',
  AzureResource = 'azure/resource',
  PatientExaminations = 'api/patients/examinations',
  PatientHistory = 'api/patients/history',
}
